export default "__VITE_ASSET__BM8eDIx9__"